import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface TrustpilotItem {
  title: string;
  author: string;
  reviewDate: string;
  imageUrl: string;
  altText: string;
  reviewText: string;
  reviewLink: string;
}

@Component({
  selector: 'app-trustpilot',
  templateUrl: './trustpilot.component.html',
  styleUrls: ['./trustpilot.component.scss'],
})
export class TrustpilotComponent implements OnInit {
  trustpilotReviews!: TrustpilotItem[];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.trustpilotReviews = this.translate.instant('home_trustpilot.reviews');
  }
}
